//@flow
import React from 'react';

import LabeledField from './LabeledField';

type Props = {
  label: string,
  labelClassName?: string,
  value?: string,
  valueClassName?: string,
  dataTestName?: string,
};

export default function StaticTextField({
  label,
  labelClassName,
  value,
  valueClassName,
  dataTestName,
}: Props) {
  return (
    <LabeledField label={label} labelClassName={labelClassName}>
      <span
        className={`input is-static ${valueClassName || ''}`}
        data-test-name={dataTestName || label}
      >
        {value}
      </span>
    </LabeledField>
  );
}



// WEBPACK FOOTER //
// ./src/view/Forms/StaticTextField.js